import React from 'react';
import { IAuditoriaZeramento13Resultado } from '../interfaces/IAuditoriaZeramento13';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaZeramento13Resultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Zeramento e Provisão de 13º Salário não é um tributo — é uma auditoria
// complementar que reúne três análises (Saldo Final não zerado em 31/12, Saldo Inicial não
// zerado em 01/01 e Provisão Mensal Ausente). Segue o mesmo padrão de seção própria já usado
// para Saldos Bancários, Depreciação, Caixa e Financeira.
const AuditoriaResumoZeramento13: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias =
    (resultado.saldoFinalNaoZerado?.length || 0) +
    (resultado.saldoInicialNaoZerado?.length || 0) +
    (resultado.provisaoMensalAusente?.length || 0);

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Zeramento e Provisão de 13º Salário</h3>
      <p className='text-muted'>
        Auditoria complementar — contas de Adiantamento de 13º Salário e Provisão para 13º Salário a Pagar devem ser
        zeradas ao final do exercício (ITG 2000; Lei nº 4.749/1965). Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Impacto Fiscal Estimado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_ZERAMENTO_13')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Zeramento e Provisão de 13º Salário</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} conta{totalOcorrencias === 1 ? '' : 's'}/competência{totalOcorrencias === 1 ? '' : 's'} com indício identificado no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Multa ECD potencial — 5% limitada a 1% da receita bruta do período (Art. 12, II, Lei nº 8.218/1991)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoZeramento13;
